import * as repositories from './repositories'
import * as stores from './stores'

export default {
  repositories,
  stores,
}
